module.exports = __webpack_public_path__ + "static/media/09-true-false.d0f28a97.png";